import type { ProductUid } from '@flashcard/shared';
import { getProductMeta } from '@flashcard/shared';

interface ProductCardProps {
  uid: ProductUid;
  selected: boolean;
  onSelect: () => void;
}

export function ProductCard({ uid, selected, onSelect }: ProductCardProps) {
  const meta = getProductMeta(uid);
  if (!meta) return null;

  return (
    <div
      className={`product-card${selected ? ' selected' : ''}`}
      onClick={onSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onSelect()}
    >
      {selected && <span className="check-mark">✓</span>}
      {meta.badge === 'premium' && <span className="badge badge-premium">Premium</span>}
      {meta.badge === 'bestseller' && <span className="badge badge-bestseller">Bestseller</span>}

      <div className={`card-preview ${meta.format} ${meta.finish}`}>85 × 55 mm</div>

      <div className="product-name">{meta.name}</div>
      <div className="product-meta">
        {meta.paper} · {meta.finish === 'matte' ? 'Matt' : meta.finish === 'gloss' ? 'Glanz' : 'Softtouch'}
      </div>
    </div>
  );
}
